<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Type" :required="true">
              <b-form-select
                @blur="$v.movement.type.$touch"
                :class="{ 'is-invalid': $v.movement.type.$error }"
                v-model="movement.type"
                :options="movementTypes"
                @change="setMovementPallets"
              />
              <div class="invalid-feedback" v-if="!$v.movement.type.required">
                Please select type
              </div>
            </form-group>

            <form-group
              label="From Branch"
              :required="true"
              v-if="
                movement.type == 'Return to supplier' ||
                movement.type == 'Inter branch transfer'
              "
            >
              <b-form-select
                @blur="$v.movement.from_branch_id.$touch"
                :class="{ 'is-invalid': $v.movement.from_branch_id.$error }"
                v-model="movement.from_branch_id"
                :options="branches"
                text-field="name"
                value-field="id"
                @change="setMovementPallets"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.from_branch_id.required"
              >
                Please select from branch
              </div>

              <h6 v-if="movement.from_branch_id" class="mt-3"><strong>{{ returnsAvailable }}</strong> Pallets On Hand</h6>
            </form-group>

            <form-group
              label="To Branch"
              :required="true"
              v-if="
                movement.type == 'Receive from supplier' ||
                movement.type == 'Inter branch transfer'
              "
            >
              <b-form-select
                @blur="$v.movement.to_branch_id.$touch"
                :class="{ 'is-invalid': $v.movement.to_branch_id.$error }"
                v-model="movement.to_branch_id"
                :options="
                  movement.type == 'Receive from supplier'
                    ? branches
                    : movementAllBranches
                "
                text-field="name"
                value-field="id"
                @change="setMovementPallets"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.to_branch_id.required"
              >
                Please select to branch
              </div>

                 <h6 v-if="movement.to_branch_id" class="mt-3"><strong>{{ branches.filter(x => x.id == movement.to_branch_id)[0].pallet_balance }}</strong> Pallets On Hand</h6>
            </form-group>

            <form-group
              label="From Supplier"
              :required="true"
              v-if="movement.type == 'Receive from supplier'"
            >
              <b-form-select
                @blur="$v.movement.from_supplier_id.$touch"
                :class="{ 'is-invalid': $v.movement.from_supplier_id.$error }"
                v-model="movement.from_supplier_id"
                :options="suppliers"
                text-field="name"
                value-field="id"
                @change="setMovementPallets"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.from_supplier_id.required"
              >
                Please select supplier
              </div>
            </form-group>

            <form-group
              label="To Supplier"
              :required="true"
              v-if="movement.type == 'Return to supplier'"
            >
              <b-form-select
                @blur="$v.movement.to_supplier_id.$touch"
                :class="{ 'is-invalid': $v.movement.to_supplier_id.$error }"
                v-model="movement.to_supplier_id"
                :options="suppliers"
                text-field="name"
                value-field="id"
                @change="setMovementPallets"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.to_supplier_id.required"
              >
                Please select to supplier
              </div>
            </form-group>

            <form-group
              :required="true"
              label="Invoice #"
            >
              <input
                @blur="$v.movement.invoice_number.$touch"
                :class="{ 'is-invalid': $v.movement.invoice_number.$error }"
                class="form-control"
                v-model="movement.invoice_number"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.invoice_number.required"
              >
                Please enter invoice #
              </div>
            </form-group>

            <form-group
              :required="movement.type != 'Inter branch transfer'"
              label="GKN"
            >
              <input
                class="form-control"
                @blur="$v.movement.gkn_number.$touch"
                :class="{ 'is-invalid': $v.movement.gkn_number.$error }"
                v-model="movement.gkn_number"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.gkn_number.required"
              >
                Please enter GKN #
              </div>
            </form-group>

            <form-group label="Remark">
              <input class="form-control" v-model="movement.remark" />
            </form-group>

            <form-group
              :required="true"
              label="Quantity"
              v-if="movement.type != null"
            >
              <input
                class="form-control"
                type="number"
                min="1"
                step="1"
                @blur="$v.movement.quantity.$touch"
                :class="{ 'is-invalid': $v.movement.quantity.$error }"
                v-model="movement.quantity"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.movement.quantity.required"
              >
                Quantity Required
              </div>
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";
import { required, requiredIf } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    movement: {
      type: {
        required,
      },
      invoice_number: {
        required
      },
      gkn_number: {
        required: requiredIf(function () {
          return (this.movement.type == "Receive from supplier" || this.movement.type == "Return to supplier" ) ;
        }),
      },
      quantity: {
       required
      },
      from_branch_id: {
        required: requiredIf(function () {
          return this.movement.type == "Inter branch transfer";
        }),
      },
      from_supplier_id: {
        required: requiredIf(function () {
          return this.movement.type == "Receive from supplier";
        }),
      },
      to_branch_id: {
        required: requiredIf(function () {
          return (
            this.movement.type == "Receive from supplier" ||
            this.movement.type == "Inter branch transfer"
          );
        }),
      },
      to_supplier_id: {
        required: requiredIf(function () {
          return this.movement.type == "Return to supplier";
        }),
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      movement: {
        to_branch_id: null,
        from_branch_id: null,
        type: null,
      },
      branches: [],
      movementAllBranches: [],
      suppliers: [],
      movementTypes: [
        "Receive from supplier",
        "Return to supplier",
        "Inter branch transfer",
      ],
      loading: false,
      openBatches: [],
      returnsAvailable: 0,
      returnsTotal: 0,

      transfersTotal: 0,

      errors: null,
      submitStatus: null,
      imageUploading: false,

      showAllSuppliersReturnFrom: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await palletRepo.branches();
        this.branches = data.branches;
        let res = await palletRepo.suppliers();
        this.suppliers = res.data.suppliers;
        let res3 = await palletRepo.movementAllBranches();
        this.movementAllBranches = res3.data.branches;
      } catch (error) {
        console.log(error);
      }
    },

    async setMovementPallets() {
      this.movement.pallets = [];

      if (this.movement.type == "Receive from supplier") {

        if (this.branches.length == 1) {
          this.movement.to_branch_id = this.branches[0].id
        }

        console.log(this.movement)
      }

      if (this.movement.type == "Return to supplier") {
        if (this.branches.length == 1) {
          this.movement.from_branch_id = this.branches[0].id;
        }

        if(this.movement.from_branch_id != null){
         this.returnsAvailable = this.branches.filter(x => x.id == this.movement.from_branch_id)[0].pallet_balance
        }
      }

      if (this.movement.type == "Inter branch transfer") {
        if (this.branches.length == 1) {
          this.movement.from_branch_id = this.branches[0].id;
        }

        if(this.movement.from_branch_id != null){
         this.returnsAvailable = this.branches.filter(x => x.id == this.movement.from_branch_id)[0].pallet_balance
        }
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();

      let invalid = false;

      if (this.movement.type == "Inter branch transfer") {
        if (this.movement.to_branch_id == this.movement.from_branch_id) {
          invalid = true;
        }
      }

      if (
        this.movement.type == "Inter branch transfer" ||
        this.movement.type == "Return to supplier"
      ) {
        if (this.returnsAvailable < this.movement.quantity) {
          invalid = true;
        }
      }

      if (this.$v.$invalid || invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          let { data } = await palletRepo.createMovement(this.movement);

          this.printMovement(
            data.movement.id,
            data.movement.pallet_movement_number
          );

          if (this.movement.type == "Receive from supplier") {
            this.$bvModal
              .msgBoxConfirm("Are you returning pallets to supplier", {
                title: "Please Confirm",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "YES",
                cancelTitle: "NO",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              })
              .then((confirm) =>
                confirm
                  ? this.returnToSupplier(data.movement)
                  : this.$emit("palletMovementCreated")
              )
              .catch((error) => console.log(error));
          } else {
            this.$emit("palletMovementCreated");
          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Whoops", {
              title: "Something went wrong",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

    async returnToSupplier() {
      this.returnsAvailable = 0;
      this.returnsTotal = 0;
      this.movement.type = "Return to supplier";
      this.movement.to_supplier_id = this.movement.from_supplier_id;
      this.movement.from_supplier_id = null;
      this.movement.from_branch_id = this.movement.to_branch_id;
      this.movement.to_branch_id = null;
      await this.getData();
    this.returnsAvailable = this.branches.filter(x => x.id == this.movement.from_branch_id)[0].pallet_balance
    },

    async printMovement(id, number) {
      try {
        let response = await palletRepo.movementPrint(id);
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(fileURL);
        console.log(number);
        //var fileLink = document.createElement("a");
        // fileLink.href = fileURL;
        // fileLink.setAttribute("download", `pallet_movement_${number}.pdf`);
        // document.body.appendChild(fileLink);

        // fileLink.click();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

